export const additionalFields = [
  {
    label: "Geo IT Partner",
    name: "geoItPartner",
    placeholder: "eg:email@unilever.com",
    inputType: "email",
    value: "geoItPartner",
  },
  {
    label: "Business Owner",
    name: "businessOwner",
    placeholder: "eg:email@unilever.com",
    inputType: "email",
    value: "businessOwner",
  },
  {
    label: "Business Request",
    name: "businessRequest",
    placeholder: "eg:email@unilever.com",
    inputType: "email",
    value: "businessRequest",
  },
  {
    label: "Manual Hour",
    name: "manualhour",
    placeholder: "Enter manual hour",
    inputType: "number",
    value: "manualhour",
  },
  {
    label: "FTE Saving",
    name: "fte",
    placeholder: "Enter FTE saving",
    inputType: "number",
    value: "fte",
  },
  // {
  //   label: "SOP Document",
  //   name: "uploadDocument",
  //   placeholder: "Select SOP document",
  //   inputType: "file",
  //   value: "uploadDocument",
  // },
];

export const skillFields = [
  {
    label: "Soft Skills",
    name: "softSkill",
    placeholder: "Search soft skills",
    value: "softSkill",
  },
  {
    label: "Transactions Skill",
    name: "transactions",
    placeholder: "Search transaction skills",
    value: "transactions",
  },
  {
    label: "Reporting Skills",
    name: "reporting",
    placeholder: "Search reporting skills",
    value: "reporting",
  },
  {
    label: "Cognitive Skills",
    name: "cognitive",
    placeholder: "Search cognitive skills",
    value: "cognitive",
  },
  {
    label: "Decisionautomations Skills",
    name: "decisionautomations",
    placeholder: "Search decisionautomations skills",
    value: "decisionautomations",
  },
];

export const prefilledForm = {
  newRequest: "New Request",
  uploadPhoto: "TBD",
  globalSkill: "TBD",
  localSkill: "TBD",
  uploadDocument: "TBD",
  businessgroup: "TBD",
  businessunit: "TBD",
  businessoption: "TBD",
  //sopDocument: "TBD",
};

export const notMandatoryFields = [
  "softSkill",
  "transactions",
  "reporting",
  "cognitive",
  "decisionautomations",
];
